import { useWishList } from '@/features/account/api/query/wishlist';
import { useRemoveCookie } from '@/hooks/use-cookies';
import { useRouter } from '@/navigation';
import { LOGIN_ROUTES } from '@/routes';
import { Cookie, SessionStorage } from '@/types/storage';
import { useQueryClient } from '@tanstack/react-query';
import { useTransition } from 'react';

export const useLogout = () => {
  const router = useRouter();
  const queryClient = useQueryClient();
  const [isTransitionPending, startTransition] = useTransition();
  const { refetch } = useWishList();

  const removeCookie = useRemoveCookie();

  return {
    logout: () => {
      removeCookie(Cookie.LOGIN_SECRET);
      removeCookie(Cookie.JUST_LOGGED_IN);
      removeCookie(Cookie.CUSTOMER_TYPE);
      removeCookie(Cookie.BASKET_ID);
      sessionStorage.removeItem(SessionStorage.AGCORE_WISHLIST_ITEMS);
      queryClient.clear();
      startTransition(() => {
        router.push(LOGIN_ROUTES.LOGIN);
        router.refresh();
        refetch();
      });
    },
    isLogoutPending: isTransitionPending,
  };
};
